import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as tags from '../../../constants';

import { TimingWrapper, TimingLabel } from './styles';

class Timing extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatDate = (datePassed) => {
    const dateJs = new Date(datePassed);
    const hours = `0${dateJs
      .getHours()
      .toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`.slice(-2);
    const minutes = `0${dateJs
      .getMinutes()
      .toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`.slice(-2);
    return `${hours}:${minutes}`;
  };

  fullTimeLabel = (resultType, stat) => {
    let fullLabel = '';
    if (resultType === 'PenaltyShootout') {
      fullLabel = 'D.c.d.r.';
    } else if (
      (stat &&
        stat.find(matchStatus => matchStatus.get('Type') === 'second_half_extra_stop')) ||
      resultType === 'AfterExtraTime'
    ) {
      fullLabel = 'D.t.s.';
    } else {
      fullLabel = 'Fine';
    }
    return fullLabel;
  };

  timingCountDown = (date, val) => {
    const start = new Date(date).getTime();
    const now = Date.now();
    const timeDiff = start - now;
    const seconds = Math.floor(timeDiff / 1000);
    const minute = Math.floor(seconds / 60);
    if (timeDiff <= 3600000 && minute > 0) {
      return `-${minute}'`;
    } else {
      return this.formatDate(val);
    }
  };

  timingCalcMinute = (time, halfTimeStart) => {
    const start = new Date(time.toJS().filter(obj => obj.Type === halfTimeStart)[0].value);
    const end = Date.now();
    const elapsed = end - start;
    const seconds = Math.floor(elapsed / 1000);
    const minute = Math.floor(seconds / 60);
    let calcTime = Number(minute);
    if (halfTimeStart === 'first_half_start') {
      calcTime += 1;
    } else if (halfTimeStart === 'second_half_start') {
      calcTime += 46;
    } else if (halfTimeStart === 'first_half_extra_start') {
      calcTime += 90;
    } else if (halfTimeStart === 'second_half_extra_start') {
      calcTime += 105;
    }
    return calcTime.toString();
  };

  timingLabel = (timing, date, isMobile, resultType) => {
    const timingDictionary = this.props.dictionary.competitionTable.timing;
    switch (timing.get('tag')) {
      case tags.PREMATCH:
        return this.timingCountDown(date, timing.get('val'));
      //return timing.get('val');
      case tags.FULLTIME:
        return this.fullTimeLabel(resultType, timing.get('stat'));
      case tags.FULLTIME90:
      case tags.FULLTIMEPENS:
        return timingDictionary[timing.get('tag')];
      case tags.SHOOTOUT:
        return 'Rigori';
      case tags.ABANDONED:
      case tags.POSTPONED:
      case tags.SUSPENDED:
      case tags.EXTRAHALFTIME:
      case tags.HALFTIME:
        return timingDictionary[timing.get('tag')];
      case tags.SECONDHALF:
        if (isMobile) {
          return `${this.timingCalcMinute(
            timing.get('stat'),
            'second_half_start',
          )}'`;
        } else {
          return `${
            timingDictionary[timing.get('tag')]
          } / ${this.timingCalcMinute(
            timing.get('stat'),
            'second_half_start',
          )}'`;
        }
      case tags.FIRSTHALF:
        if (isMobile) {
          return `${this.timingCalcMinute(
            timing.get('stat'),
            'first_half_start',
          )}'`;
        } else {
          return `${
            timingDictionary[timing.get('tag')]
          } / ${this.timingCalcMinute(
            timing.get('stat'),
            'first_half_start',
          )}'`;
        }
      case tags.EXTRASECONDHALF:
        if (isMobile) {
          return `${this.timingCalcMinute(
            timing.get('stat'),
            'second_half_extra_start',
          )}'`;
        } else {
          return `${
            timingDictionary[timing.get('tag')]
          } / ${this.timingCalcMinute(
            timing.get('stat'),
            'second_half_extra_start',
          )}'`;
        }
      case tags.EXTRAFIRSTHALF:
        if (isMobile) {
          return `${this.timingCalcMinute(
            timing.get('stat'),
            'first_half_extra_start',
          )}'`;
        } else {
          return `${
            timingDictionary[timing.get('tag')]
          } / ${this.timingCalcMinute(
            timing.get('stat'),
            'first_half_extra_start',
          )}'`;
        }
      default:
        if (isMobile) {
          return `${timing.get('val')}`;
        } else {
          return `${timingDictionary[timing.get('tag')]} / ${timing.get('val')}`;
        }
    }
  };

  isEnded = (timing) => {
    if (timing.get('tag') === tags.FULLTIME) {
      return true;
    }
    return false;
  };

  render() {
    const {
      timing,
      isLive,
      isMobile,
      date,
      isWhite,
      margin,
      resultType,
      size,
    } = this.props;

    return (
      <TimingWrapper margin={margin}>
        <TimingLabel
          color={isLive ? 'liveColor' : isWhite ? 'white' : 'black'}
          font={
            isLive || this.isEnded(timing) ? 'narrowMedium' : 'narrowRegular'
          }
          size={size}
          isMobile={isMobile}
        >
          {this.timingLabel(timing, date, isMobile, resultType)}
        </TimingLabel>
      </TimingWrapper>
    );
  }
}

Timing.propTypes = {
  timing: PropTypes.shape({
    tag: PropTypes.string,
    val: PropTypes.any,
    size: PropTypes.any,
  }),
  date: PropTypes.any,
  dictionary: PropTypes.any,
  isLive: PropTypes.any,
  isMobile: PropTypes.bool,
  isWhite: PropTypes.bool,
  margin: PropTypes.string,
  resultType: PropTypes.any,
  size: PropTypes.any,
};

export default Timing;



// WEBPACK FOOTER //
// ./src/components/TimeResults/Timing/index.js